(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    var form = document.getElementById('article-subscribe-form');
    if (!form) return;

    var messageEl = form.querySelector('[data-mc-message]');
    var emailInput = form.querySelector('input[type="email"]');

    function showMessage(text, type) {
      if (!messageEl) return;
      messageEl.innerHTML = text;
      messageEl.classList.remove('form-join-community__message--error', 'form-join-community__message--success');
      messageEl.classList.add('form-join-community__message--' + type);
      messageEl.hidden = false;
    }

    function jsonp(url, callback) {
      var cbName = 'mcArticleCb_' + Date.now() + '_' + Math.floor(Math.random() * 1000000);
      var script = document.createElement('script');
      var timeout = setTimeout(function () {
        cleanup();
        callback({ result: 'error', msg: 'timeout' });
      }, 10000);

      function cleanup() {
        clearTimeout(timeout);
        delete window[cbName];
        if (script.parentNode) script.parentNode.removeChild(script);
      }

      window[cbName] = function (data) {
        cleanup();
        callback(data);
      };

      script.onerror = function () {
        cleanup();
        callback({ result: 'error', msg: 'network' });
      };

      script.src = url + (url.indexOf('?') === -1 ? '?' : '&') + 'c=' + cbName;
      document.body.appendChild(script);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var email = emailInput ? emailInput.value.trim() : '';
      if (!email || (emailInput && !emailInput.checkValidity())) {
        showMessage('Please enter a valid email address.', 'error');
        if (emailInput) emailInput.focus();
        return;
      }

      // Mailchimp's post-json reads the fields most reliably when they come
      // before the u/id params, so prepend the collected fields to the action.
      var action = form.getAttribute('action');
      var queryIndex = action.indexOf('?');
      var base = queryIndex === -1 ? action : action.slice(0, queryIndex);
      var actionParams = queryIndex === -1 ? '' : action.slice(queryIndex + 1);

      var params = new URLSearchParams();
      var fields = form.querySelectorAll('input[name]');
      for (var i = 0; i < fields.length; i++) {
        var field = fields[i];
        if (field.type === 'submit' || field.type === 'button') continue;
        params.append(field.name, field.value);
      }

      var query = params.toString();
      if (actionParams) {
        query = query + '&' + actionParams;
      }
      var requestUrl = base + '?' + query;

      form.classList.add('is-loading');
      if (messageEl) messageEl.hidden = true;

      jsonp(requestUrl, function (data) {
        form.classList.remove('is-loading');

        if (data && data.result === 'success') {
          form.reset();
          if (form.dataset.successUrl) {
            window.location.href = form.dataset.successUrl;
          }
          return;
        } else {
          var msg = (data && data.msg) || 'Something went wrong. Please try again.';
          msg = String(msg).replace(/^\d+\s*-\s*/, '');
          showMessage(msg, 'error');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  const cartSection = document.getElementById('cart-section');
  if (!cartSection) return;

  const freeShippingThreshold = parseInt(cartSection.dataset.freeShipping, 10) || 0;

  function money(cents) {
    const amount = (cents / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  async function changeCartLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
    return res.json();
  }

  function renderSummary(cart) {
    const summary = document.getElementById('cart-summary');
    if (!summary) return;

    let discountsHtml = '';
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      cart.cart_level_discount_applications.forEach(function (d) {
        discountsHtml += '<li class="order-summary__item order-summary__item--save">' +
          '<span>' + d.title + '</span>' +
          '<span>-' + money(d.total_allocated_amount) + '</span></li>';
      });
    }

    let savingsHtml = '';
    if (cart.total_discount > 0) {
      savingsHtml = '<li class="order-summary__item order-summary__item--save">' +
        '<span>Savings</span><span>-' + money(cart.total_discount) + '</span></li>';
    }

    let shippingBarHtml = '';
    if (freeShippingThreshold > 0) {
      const remaining = freeShippingThreshold - cart.total_price;
      if (remaining > 0) {
        const progress = Math.round(cart.total_price * 100 / freeShippingThreshold);
        shippingBarHtml = '<div class="order-summary__shipping-bar shipping-bar" style="--progress: ' + progress + '%;">' +
          '<div class="shipping-bar__title">You\'re <b>' + money(remaining) + '</b> away from free shipping!</div>' +
          '<div class="shipping-bar__track"><div class="shipping-bar__line"></div>' +
          '<span class="shipping-bar__icon border-gradient"><span class="--icon-delivery"></span></span></div>' +
          '<div class="shipping-bar__caption">Free Shipping</div></div>';
      } else {
        shippingBarHtml = '<div class="order-summary__shipping-bar shipping-bar" style="--progress: 100%;">' +
          '<div class="shipping-bar__title">🎉 You have free shipping!</div>' +
          '<div class="shipping-bar__track"><div class="shipping-bar__line"></div>' +
          '<span class="shipping-bar__icon border-gradient"><span class="--icon-delivery"></span></span></div>' +
          '<div class="shipping-bar__caption">Free Shipping</div></div>';
      }
    }

    summary.innerHTML =
      '<div class="order-summary__title">Order summary</div>' +
      '<ul class="order-summary__list">' +
        '<li class="order-summary__item"><span>Original price</span><span>' + money(cart.original_total_price) + '</span></li>' +
        discountsHtml +
        savingsHtml +
      '</ul>' +
      '<div class="order-summary__bottom">' +
        shippingBarHtml +
        '<div class="order-summary__total"><span>Total</span><span>' + money(cart.total_price) + '</span></div>' +
      '</div>' +
      '<button type="submit" name="checkout" form="cart-form" class="order-summary__button button"><span>Proceed to Checkout</span></button>';
  }

  function renderCartTitle(cart) {
    const title = cartSection.querySelector('.card__title');
    if (title) title.innerHTML = 'Your cart <span>(' + cart.item_count + ')</span>';
  }

  function removeItemRow(line) {
    const row = cartSection.querySelector('.card__item[data-line="' + line + '"]');
    if (row) row.remove();
    // Re-index remaining rows
    cartSection.querySelectorAll('.card__item').forEach(function (el, i) {
      const newLine = i + 1;
      el.dataset.line = newLine;
      const qEl = el.querySelector('[data-cart-quantity]');
      if (qEl) qEl.dataset.line = newLine;
      const rmEl = el.querySelector('[data-remove-item]');
      if (rmEl) rmEl.dataset.line = newLine;
    });
  }

  function showEmptyCart() {
    const container = cartSection.querySelector('.card__container');
    if (!container) return;
    container.innerHTML =
      '<div class="card__empty">' +
        '<p>Your cart is empty.</p>' +
        '<a href="/collections" class="button button--gradient"><span>Continue Shopping</span></a>' +
      '</div>';
  }

  function setLoading(state) {
    cartSection.style.opacity = state ? '0.6' : '';
    cartSection.style.pointerEvents = state ? 'none' : '';
  }

  let debounceTimer;

  function scheduleCartUpdate(line, qty) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(async function () {
      setLoading(true);
      try {
        const cart = await changeCartLine(line, qty);
        renderSummary(cart);
        renderCartTitle(cart);
        if (cart.item_count === 0) showEmptyCart();
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      } finally {
        setLoading(false);
      }
    }, 400);
  }

  // app.js sets valueElement.value directly (no event fired) — intercept the click on +/- buttons
  cartSection.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-quantity-plus], [data-quantity-minus]');
    if (!btn) return;
    const qEl = btn.closest('[data-cart-quantity]');
    if (!qEl) return;
    // app.js runs synchronously on click; read value after it finishes
    setTimeout(function () {
      const line = parseInt(qEl.dataset.line, 10);
      const qty = parseInt(qEl.querySelector('[data-quantity-value]').value, 10) || 1;
      scheduleCartUpdate(line, qty);
    }, 0);
  });

  // Direct keyboard input in the number field
  cartSection.addEventListener('change', function (e) {
    const input = e.target.closest('[data-quantity-value]');
    if (!input) return;
    const qEl = input.closest('[data-cart-quantity]');
    if (!qEl) return;
    const line = parseInt(qEl.dataset.line, 10);
    const qty = parseInt(input.value, 10) || 1;
    scheduleCartUpdate(line, qty);
  });

  // Remove item
  cartSection.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-remove-item]');
    if (!btn) return;
    e.preventDefault();
    const line = parseInt(btn.dataset.line, 10);
    setLoading(true);
    try {
      const cart = await changeCartLine(line, 0);
      if (cart.item_count === 0) {
        showEmptyCart();
      } else {
        removeItemRow(line);
        renderSummary(cart);
        renderCartTitle(cart);
      }
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    } finally {
      setLoading(false);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var WARRANTY_VALUE = 'Replacement Part / Warranty';
    var MISSING_PIECE_VALUE = 'Missing Puzzle Piece';
    var HEALTH_VALUE = 'Health or Safety Concern';

    var categorySelect = document.getElementById('help-category-select');
    var subFields = document.getElementById('product-part');
    var subSelect = document.getElementById('help-subcategory-select');
    var healthNote = document.getElementById('help-subcategory-note');
    var missingPieceFields = document.getElementById('missing-piece-fields');

    if (!categorySelect || !subFields || !subSelect) return;

    var contactForm = categorySelect.form;

    // Each category in the first select reveals its own dependent group:
    // "Replacement Part / Warranty" -> the sub-category select,
    // "Missing Puzzle Piece" -> the puzzle detail fields.
    // Note: visibility only. Fields are disabled at submit time instead of
    // here, because the theme's custom select renders its own markup from the
    // native element and would stay visually disabled after being re-enabled.
    function applyCategoryState() {
      subFields.hidden = categorySelect.value !== WARRANTY_VALUE;

      if (missingPieceFields) {
        missingPieceFields.hidden = categorySelect.value !== MISSING_PIECE_VALUE;
      }

      applySubcategoryState();
    }

    function applySubcategoryState() {
      if (!healthNote) return;
      // Note is visible only while the dependent group is shown AND
      // "Health or Safety Concern" is the chosen sub-option.
      healthNote.hidden = subFields.hidden || subSelect.value !== HEALTH_VALUE;
    }

    // Disabled fields are not submitted, so anything switched off here never
    // reaches the notification email. Doing this at submit time (rather than
    // on every category change) keeps the visible inputs fully interactive.
    //
    // Only our own contact[...] fields are touched. Shopify injects its own
    // hidden inputs into the form (form_type, utf8, the reCAPTCHA token), and
    // the token is still empty at submit time because reCAPTCHA fills it in
    // asynchronously — disabling it would drop it from the request and the
    // submission would fail with "Missing CAPTCHA token".
    if (contactForm) {
      contactForm.addEventListener('submit', function () {
        var fields = contactForm.querySelectorAll(
          'input[name^="contact["], select[name^="contact["], textarea[name^="contact["]'
        );
        for (var i = 0; i < fields.length; i++) {
          var field = fields[i];
          if (field.required || field.type === 'submit' || field.type === 'button') continue;

          // Fields inside a hidden dependent group.
          var group = field.closest('[hidden]');
          if (group) {
            field.disabled = true;
            continue;
          }

          // Empty optional fields, so the email has no blank rows.
          if (field.type === 'checkbox' || field.type === 'radio') {
            if (!field.checked) field.disabled = true;
            continue;
          }
          if (!field.value || !field.value.trim()) field.disabled = true;
        }
      });
    }

    // The theme's custom select fires "selectCallback" on change with detail.select.
    document.addEventListener('selectCallback', function (e) {
      var select = e.detail && e.detail.select;
      if (!select) return;
      if (select.id === 'help-category-select') applyCategoryState();
      if (select.id === 'help-subcategory-select') applySubcategoryState();
    });

    // Fallback for the native <select>s (if the custom select isn't enhanced)
    // and to restore state on load (validation errors re-render with a value).
    categorySelect.addEventListener('change', applyCategoryState);
    subSelect.addEventListener('change', applySubcategoryState);
    applyCategoryState();
  })();

  // Phone field: allow digits and common phone formatting only (+ ( ) - space).
  (function () {
    var phone = document.querySelector('[data-phone-input]');
    if (!phone) return;

    var ALLOWED = /[^0-9+()\-\s]/g;

    function sanitize() {
      var cleaned = phone.value.replace(ALLOWED, '');
      if (cleaned !== phone.value) {
        var pos = phone.selectionStart - (phone.value.length - cleaned.length);
        phone.value = cleaned;
        // Restore caret position after stripping invalid characters.
        try { phone.setSelectionRange(pos, pos); } catch (e) {}
      }
    }

    // Block invalid printable keys before they are entered.
    phone.addEventListener('keypress', function (e) {
      if (e.ctrlKey || e.metaKey) return;
      if (e.key && e.key.length === 1 && /[^0-9+()\-\s]/.test(e.key)) {
        e.preventDefault();
      }
    });

    // Catch paste, autofill, and any other input.
    phone.addEventListener('input', sanitize);
  })();

  // After a submit Shopify reloads the page at the top, leaving the success or
  // error message out of view — which reads as "nothing happened". Bring it
  // into view and move focus there for screen readers.
  (function () {
    var message = document.querySelector('[data-form-message]');
    if (!message) return;

    if (message.scrollIntoView) {
      message.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    message.focus();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    // Bind to this footer form by id: other pages may render additional
    // [data-mc-subscribe] forms (e.g. the article sidebar) earlier in the DOM.
    var form = document.getElementById('mc-embedded-subscribe-form');
    if (!form) return;

    var messageEl = form.querySelector('[data-mc-message]');
    var emailInput = form.querySelector('input[type="email"]');

    function showMessage(text, type) {
      if (!messageEl) return;
      messageEl.innerHTML = text;
      messageEl.classList.remove('form-subscribe__message--error', 'form-subscribe__message--success');
      messageEl.classList.add('form-subscribe__message--' + type);
      messageEl.hidden = false;
    }

    function jsonp(url, callback) {
      var cbName = 'mcCallback_' + Date.now() + '_' + Math.floor(Math.random() * 1000000);
      var script = document.createElement('script');
      var timeout = setTimeout(function () {
        cleanup();
        callback({ result: 'error', msg: 'timeout' });
      }, 10000);

      function cleanup() {
        clearTimeout(timeout);
        delete window[cbName];
        if (script.parentNode) script.parentNode.removeChild(script);
      }

      window[cbName] = function (data) {
        cleanup();
        callback(data);
      };

      script.onerror = function () {
        cleanup();
        callback({ result: 'error', msg: 'network' });
      };

      script.src = url + (url.indexOf('?') === -1 ? '?' : '&') + 'c=' + cbName;
      document.body.appendChild(script);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var email = emailInput ? emailInput.value.trim() : '';
      if (!email || (emailInput && !emailInput.checkValidity())) {
        showMessage('Please enter a valid email address.', 'error');
        if (emailInput) emailInput.focus();
        return;
      }

      // Build the JSONP request URL. Mailchimp's post-json endpoint reads the
      // form fields most reliably when they come BEFORE the u/id params, so we
      // split the action into base + query and prepend the collected fields.
      // Note: the f_id param is intentionally omitted from the action — it makes
      // post-json return "Blank email address".
      var action = form.getAttribute('action');
      var queryIndex = action.indexOf('?');
      var base = queryIndex === -1 ? action : action.slice(0, queryIndex);
      var actionParams = queryIndex === -1 ? '' : action.slice(queryIndex + 1);

      var params = new URLSearchParams();
      var fields = form.querySelectorAll('input[name], select[name], textarea[name]');
      for (var i = 0; i < fields.length; i++) {
        var field = fields[i];
        if (field.type === 'submit' || field.type === 'button') continue;
        if (field.type === 'checkbox' || field.type === 'radio') {
          if (!field.checked) continue;
        }
        params.append(field.name, field.value);
      }

      var query = params.toString();
      if (actionParams) {
        query = query + '&' + actionParams;
      }
      var requestUrl = base + '?' + query;

      form.classList.add('is-loading');
      if (messageEl) messageEl.hidden = true;

      jsonp(requestUrl, function (data) {
        form.classList.remove('is-loading');

        if (data && data.result === 'success') {
          form.reset();
          if (form.dataset.successUrl) {
            window.location.href = form.dataset.successUrl;
          }
          return;
        } else {
          var msg = (data && data.msg) || 'Something went wrong. Please try again.';
          // Mailchimp prefixes some errors with a numeric code like "0 - ".
          msg = String(msg).replace(/^\d+\s*-\s*/, '');
          showMessage(msg, 'error');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
// The header is fixed, so the page needs padding equal to its height.
// Measure it instead of hardcoding, since the height changes between
// breakpoints and when the menu wraps.
(function () {
  function setHeaderOffset() {
    const group = document.querySelector('.shopify-section-group-header-group');
    if (!group) return;
    document.documentElement.style.setProperty(
      '--header-offset',
      group.offsetHeight + 'px'
    );
  }

  setHeaderOffset();
  window.addEventListener('load', setHeaderOffset);
  window.addEventListener('resize', setHeaderOffset);
  document.addEventListener('DOMContentLoaded', setHeaderOffset);

  // Solid background once the page scrolls away from the top, so the
  // header stays readable over the content. Kept here rather than
  // relying on app.js's _header-scroll class, which doesn't always run.
  function setScrolledState() {
    const group = document.querySelector('.shopify-section-group-header-group');
    if (!group) return;
    group.classList.toggle('is-scrolled', window.scrollY > 1);
  }

  setScrolledState();
  window.addEventListener('scroll', setScrolledState, { passive: true });
})();

document.addEventListener('click', function(e) {
  const link = e.target.closest('[data-locale-code]');
  if (!link) return;
  e.preventDefault();
  const form = document.getElementById(link.dataset.localeForm);
  if (!form) return;
  form.querySelector('[name="locale_code"]').value = link.dataset.localeCode;
  form.submit();
});

// Live search. Queries Shopify's predictive search endpoint and renders
// matching products under the header field.
(function () {
  var form = document.querySelector('[data-search-form]');
  if (!form) return;

  var input = form.querySelector('[data-search-input]');
  var panel = form.querySelector('[data-search-panel]');
  var inner = form.querySelector('[data-search-panel-inner]');
  var status = form.querySelector('[data-search-status]');
  if (!input || !panel || !inner) return;

  var MIN_LENGTH = 2;
  var DEBOUNCE_MS = 250;
  var LIMIT = 5;

  // Routes come from Liquid so the locale prefix (/en-int) is preserved.
  var predictiveUrl = form.dataset.predictiveUrl || '/search/suggest';
  var searchUrl = form.dataset.searchResultsUrl || '/search';
  var hidePrices = form.dataset.hidePrices === 'true';

  var timer = null;
  var controller = null;
  var activeIndex = -1;

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function close() {
    panel.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    activeIndex = -1;
  }

  function open() {
    panel.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function announce(text) {
    if (status) status.textContent = text;
  }

  function items() {
    return inner.querySelectorAll('.live-search__item');
  }

  function setActive(index) {
    var list = items();
    if (!list.length) return;

    if (index < 0) index = list.length - 1;
    if (index >= list.length) index = 0;

    for (var i = 0; i < list.length; i++) {
      list[i].classList.toggle('is-active', i === index);
    }
    activeIndex = index;
    list[index].scrollIntoView({ block: 'nearest' });
  }

  function allResultsUrl(term) {
    return searchUrl + '?q=' + encodeURIComponent(term) + '&type=product';
  }

  function render(products, term) {
    if (!products.length) {
      inner.innerHTML =
        '<p class="live-search__message">No products found for &ldquo;' +
        escapeHtml(term) + '&rdquo;</p>';
      announce('No products found');
      open();
      return;
    }

    var html = '<div class="live-search__heading">Products</div>';

    products.forEach(function (product) {
      var image = product.featured_image && product.featured_image.url
        ? '<img src="' + escapeHtml(product.featured_image.url) +
          '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="48" height="48">'
        : '';

      var price = '';
      if (!hidePrices && product.price !== undefined) {
        // compare_at_price is only meaningful when it exceeds the current price.
        var onSale = product.compare_at_price &&
          Number(product.compare_at_price) > Number(product.price);
        price = '<div class="live-search__price">' +
          (onSale ? '<s>' + formatMoney(product.compare_at_price) + '</s>' : '') +
          formatMoney(product.price) +
          '</div>';
      }

      html +=
        '<a class="live-search__item" href="' + escapeHtml(product.url) + '" role="option">' +
          '<span class="live-search__image">' + image + '</span>' +
          '<span class="live-search__info">' +
            '<span class="live-search__title">' + escapeHtml(product.title) + '</span>' +
            price +
          '</span>' +
        '</a>';
    });

    html +=
      '<div class="live-search__footer">' +
        '<a class="live-search__all" href="' + escapeHtml(allResultsUrl(term)) + '">See all results</a>' +
      '</div>';

    inner.innerHTML = html;
    announce(products.length + ' products found');
    open();
  }

  // The predictive endpoint returns prices as decimal strings ("18.00").
  function formatMoney(value) {
    var amount = Number(value);
    if (isNaN(amount)) return '';
    return window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? amount.toFixed(2) + ' ' + window.Shopify.currency.active
      : '$' + amount.toFixed(2);
  }

  function search(term) {
    // Abort the previous request so a slow response cannot overwrite a newer one.
    if (controller) controller.abort();
    controller = new AbortController();

    var url = predictiveUrl +
      '?q=' + encodeURIComponent(term) +
      '&resources[type]=product' +
      '&resources[limit]=' + LIMIT +
      '&resources[options][unavailable_products]=last';

    fetch(url, {
      signal: controller.signal,
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Search failed');
        return response.json();
      })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        render(products, term);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        // Network or endpoint failure: fail quietly, the form still submits.
        close();
      });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    clearTimeout(timer);

    if (term.length < MIN_LENGTH) {
      close();
      return;
    }
    timer = setTimeout(function () { search(term); }, DEBOUNCE_MS);
  });

  input.addEventListener('keydown', function (e) {
    if (panel.hidden) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActive(activeIndex + 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActive(activeIndex - 1);
    } else if (e.key === 'Enter') {
      var list = items();
      if (activeIndex >= 0 && list[activeIndex]) {
        e.preventDefault();
        window.location.href = list[activeIndex].href;
      }
    } else if (e.key === 'Escape') {
      close();
      input.blur();
    }
  });

  input.addEventListener('focus', function () {
    if (input.value.trim().length >= MIN_LENGTH && inner.innerHTML) open();
  });

  // Shopify's full search matches whole words and prefixes only, so "slim"
  // misses "Cra-Z-Slimy". Appending a wildcard to each term makes the results
  // page match the same products the predictive dropdown already shows.
  form.addEventListener('submit', function () {
    var term = input.value.trim();
    if (!term || term.indexOf('*') !== -1) return;

    input.value = term.split(/\s+/).map(function (word) {
      // Quoted phrases and field filters must be left exactly as typed.
      if (/["':]/.test(word)) return word;
      return word + '*';
    }).join(' ');
  });

  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thank-you-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var button = document.querySelector('[data-copy-code]');
    if (!button) return;

    var feedback = document.querySelector('[data-copy-feedback]');
    var resetTimer = null;

    function showCopied() {
      button.classList.add('is-copied');
      if (feedback) feedback.hidden = false;

      clearTimeout(resetTimer);
      resetTimer = setTimeout(function () {
        button.classList.remove('is-copied');
        if (feedback) feedback.hidden = true;
      }, 3000);
    }

    // Fallback for browsers without the async clipboard API (and non-HTTPS).
    function legacyCopy(text) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'absolute';
      field.style.left = '-9999px';
      document.body.appendChild(field);
      field.select();
      try {
        document.execCommand('copy');
      } catch (e) {
        // Copy is unavailable — leave the code visible for manual selection.
      }
      document.body.removeChild(field);
    }

    button.addEventListener('click', function () {
      var code = button.dataset.code || '';
      if (!code) return;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied, function () {
          legacyCopy(code);
          showCopied();
        });
      } else {
        legacyCopy(code);
        showCopied();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
